export default __webpack_public_path__ + "static/media/ic_celebration.a949174d.svg";